"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _zip = _interopRequireDefault(require("lodash/fp/zip"));
var _every = _interopRequireDefault(require("lodash/fp/every"));
var argsEq = function argsEq(left) {
  return function (right) {
    if (left.length !== right.length) {
      return false;
    }
    return (0, _compose["default"])((0, _every["default"])(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        leftArg = _ref2[0],
        rightArg = _ref2[1];
      return leftArg === rightArg;
    }), _zip["default"])(left, right);
  };
};
function memoLast(func) {
  var lastArgs;
  var lastResult;
  var called = false;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (called && argsEq(lastArgs)(args)) {
      return lastResult;
    }
    called = true;
    lastResult = func.apply(void 0, args);
    lastArgs = args;
    return lastResult;
  };
}
var _default = exports["default"] = memoLast;